import { render, staticRenderFns } from "./main-sidebar.vue?vue&type=template&id=20f4ef8c&scoped=true&"
import script from "./main-sidebar.vue?vue&type=script&lang=js&"
export * from "./main-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./main-sidebar.vue?vue&type=style&index=0&id=20f4ef8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f4ef8c",
  null
  
)

export default component.exports